"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstLetterBrandsParsed = void 0;
function getFirstLetterBrandsParsed(brands) {
    if (!brands.list.length) {
        return [];
    }
    return brands.list.reduce((acc, cur) => {
        let currentChar = cur.name.toUpperCase().charAt(0);
        if (currentChar < 'A') {
            currentChar = '#';
        }
        if (acc[1] != currentChar) {
            acc[0].push({ isLetter: true, letter: currentChar });
            acc[1] = currentChar;
        }
        acc[0].push(cur);
        return acc;
    }, [[], null])[0];
}
exports.getFirstLetterBrandsParsed = getFirstLetterBrandsParsed;
